/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "transparent",
    width: "100px",
  },
  paper: {
    overflow: "hidden",
    width: "auto",
  },
  scrollPaper: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  buttonStyle: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.text.primary,
  },
  closeBtn: {
    display: "flex",
    justifyContent: "end",
    marginLeft: "auto",
    marginTop: theme.spacing(-2.8),
    cursor: "pointer",
    textAlign: "right",
  },
  closeButton: {
    display: "flex",
    justifyContent: "end",
    cursor: "pointer",
    textAlign: "right",
    marginLeft: "auto",
  },
  deleteButtonStyler: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  bold: {
    fontWeight: "bold",
  },
  dialogContent: {
    paddingBottom: theme.spacing(5.5),
  },
  flex: {
    display: "flex",
    fontWeight: "bold",
  },
}));
